"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
interface HydrationGateProps {
  fallback: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Two-pass render gate. Renders `fallback` on the server and during the first client paint,
 * then swaps to `children` after mount.
 *
 * Use this when a subtree's initial render depends on browser-only data (e.g. sessionStorage)
 * and the SSR snapshot would otherwise diverge from the post-hydration snapshot, producing a
 * visible flash. The official React pattern for "handling different client and server content".
 */
export function HydrationGate(t0) {
  const $ = _c(4);
  const {
    fallback,
    children
  } = t0;
  const [didMount, setDidMount] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setDidMount(true);
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const t3 = didMount ? children : fallback;
  let t4;
  if ($[2] !== t3) {
    t4 = <>{t3}</>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
}